module.exports = __webpack_public_path__ + "static/cosi6s-49aa5c5209fa199e3536daaa15247c8a.jpg";